import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ShowTableDaftarBankMasuk } from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import {
  SearchBar,
  Loader,
  usePagination,
  ButtonModifier,
} from "../../../components";
import { Box, Typography, Divider, Pagination, Button } from "@mui/material";

const TampilDaftarBankMasuk = () => {
  const { user, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();

  const { screenSize } = useStateContext();
  const [isFetchError, setIsFetchError] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [bankMasuksData, setBankMasuksData] = useState([]);
  const kode = null;

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(1);
  const PER_PAGE = 20;

  // Get current posts
  const indexOfLastPost = page * PER_PAGE;
  const indexOfFirstPost = indexOfLastPost - PER_PAGE;
  const tempPosts = bankMasuksData.filter((val) => {
    if (searchTerm === "") {
      return val;
    } else if (
      val.no === parseInt(searchTerm) ||
      val.noBukti.toUpperCase().includes(searchTerm.toUpperCase()) ||
      val.tglBankMasukFormatted.toString().includes(searchTerm) ||
      val.COA.kodeCOA.toString().includes(searchTerm.toUpperCase()) ||
      val.COA.namaCOA.toString().includes(searchTerm.toUpperCase()) ||
      val.keterangan
        .toString()
        .toUpperCase()
        .includes(searchTerm.toUpperCase()) ||
      val.cabang.toString().includes(searchTerm.toUpperCase())
    ) {
      return val;
    }
  });
  const currentPosts = tempPosts.slice(indexOfFirstPost, indexOfLastPost);

  const count = Math.ceil(tempPosts.length / PER_PAGE);
  const _DATA = usePagination(bankMasuksData, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  useEffect(() => {
    if (user.tipeUser === "OWN/DIREKSI") {
      getBankMasukAllCabangsData();
    } else {
      getBankMasuksData();
    }
  }, []);

  const getBankMasukAllCabangsData = async () => {
    setLoading(true);
    try {
      const allBankMasuks = await axios.post(`${tempUrl}/bankMasukAllCabangs`, {
        dariTgl: user.periode.periodeAwal,
        sampaiTgl: user.periode.periodeAkhir,
        id: user._id,
        token: user.token,
      });
      setBankMasuksData(allBankMasuks.data);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getBankMasuksData = async () => {
    setLoading(true);
    try {
      const allBankMasuks = await axios.post(`${tempUrl}/bankMasuks`, {
        dariTgl: user.periode.periodeAwal,
        sampaiTgl: user.periode.periodeAkhir,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      setBankMasuksData(allBankMasuks.data);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Box>
      <Typography color="#757575">Finance</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Daftar Bank Masuk
      </Typography>
      <Typography sx={subTitleText}>
        Periode : {user.periode.namaPeriode}
      </Typography>
      <Box sx={buttonModifierContainer}>
        {user.tipeUser !== "OWN/DIREKSI" && (
          <ButtonModifier
            id={"/"}
            kode={kode}
            addLink={`/daftarBankMasuk/bankMasuk/tambahBankMasuk`}
            editLink={`/`}
            deleteUser={"/"}
          />
        )}
      </Box>
      <Divider sx={dividerStyle} />
      <Box sx={searchBarContainer}>
        <SearchBar setSearchTerm={setSearchTerm} />
        <Button
          variant="contained"
          type="submit"
          color="primary"
          disableElevation
        >
          Cari
        </Button>
      </Box>
      <Box sx={tableContainer}>
        <ShowTableDaftarBankMasuk
          currentPosts={currentPosts}
          searchTerm={searchTerm}
          tipeUser={user.tipeUser}
        />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={count}
          page={page}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Box>
  );
};

export default TampilDaftarBankMasuk;

const container = {
  p: 4,
};

const subTitleText = {
  fontWeight: "900",
};

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const dividerStyle = {
  pt: 4,
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};
